export default __webpack_public_path__ + "static/media/khwaabi.06603da1.jpg";